import 'imagesloaded';

(function (jQuery) {
  if (jQuery('.layout--mosaic').length < 1) {
    return;
  }

  jQuery('.layout--mosaic .blocks').imagesLoaded({}, function () {
    jQuery('.layout--mosaic .blocks').isotope({
      itemSelector: '.block',
      gutter: 0
    });
  });
})(jQuery);
